import { cn } from '@cibli/shared';
import { CSSProperties } from 'react';

import { getContrastTextColor } from '../templates/helpers';
import { CVViewMode } from '../templates/types';

const CVContainer = ({
  children,
  accentColor,
  mode,
}: {
  children: React.ReactNode;
  accentColor: string;
  mode: CVViewMode;
}) => {
  const textColor = getContrastTextColor(accentColor);
  return (
    <div
      className={cn('relative', mode === 'print' ? 'min-h-[297mm]' : undefined)}
      style={
        {
          '--primary': accentColor,
          '--primary-foreground': textColor,
          '--color-primary-foreground': textColor,
          '--accent': accentColor,
          '--ring': accentColor,
        } as CSSProperties
      }
    >
      {children}
    </div>
  );
};

export default CVContainer;
